import { atom } from "jotai";

export const orderToAssignAtom = atom<string | undefined>(undefined);
